import { snakeCase } from "change-case";
import { getAnalytics, logEvent, setUserProperties } from "firebase/analytics";
import mixpanel from "mixpanel-browser";
import { getUserRoleBooleans } from "../contexts/AuthContext";
import { isEmpty, pickBy } from "lodash";
import { initializeApp } from "firebase/app";

const isProduction = process.env.NEXT_PUBLIC_TRANSFEZ_APP_ENV == "PRODUCTION";

export const initEvents = () => {
  initsMixpanel();
  initsFirebase();
};

const initsMixpanel = () => {
  // "26c0d29e656bc08045814bb50e4714d7" // prod prod
  const key = isProduction
    ? "1807a591fb867a268442ca324c3a40cb" // demo prod
    : "a1f98ddc14d5e6e22cc32efb68938b1f"; // staging ramai2
  // const debug = !isProduction
  mixpanel.init(key, { debug: true }); // request ivan selalu debug mode biar bisa dicek dari console
};

const firebaseConfig = isProduction
  ? {
      apiKey: "AIzaSyCp6Hz3X9XY3c0MBo3Bj3x-xtf5NhPNPNs",
      authDomain: "transfez-b2b-production.firebaseapp.com",
      projectId: "transfez-b2b-production",
      storageBucket: "transfez-b2b-production.appspot.com",
      messagingSenderId: "431457978503",
      appId: "1:431457978503:web:a6ef567b0a29707d411022",
      measurementId: "G-637KMH86VM",
    }
  : {
      apiKey: "AIzaSyBtBAqBkzLGc3rgX7dkxtwMD9vLJcHUswI",
      authDomain: "transfez-b2b-staging.firebaseapp.com",
      projectId: "transfez-b2b-staging",
      storageBucket: "transfez-b2b-staging.appspot.com",
      messagingSenderId: "1041904216143",
      appId: "1:1041904216143:web:1068c8ac4379b332c0a23a",
      measurementId: "G-JPGG63QT2J",
    };

const initsFirebase = () => initializeApp(firebaseConfig);

const firebaseAnalytics = () => {
  const app = initsFirebase();
  const analytics = getAnalytics(app);
  return analytics;
};

export const eventsTracker = (eventName, object = {}) => {
  const obj = pickBy(object, (_, key) => key !== "token");

  const event_name = snakeCase(eventName);
  // dont remove
  // habis beres dicabut
  if (!isProduction) {
    // console.log(
    //   "%cevent_name:" + `%c ${event_name}`,
    //   "background: red; color: white",
    //   "color:black"
    // );
    // !isEmpty(obj) &&
    //   console.log(
    //     "%cevent_payload:" + `%c ${JSON.stringify(obj)}`,
    //     "background: blue; color: white",
    //     "color: black"
    //   );
  }
  // dont remove

  logEvent(firebaseAnalytics(), event_name, obj);
  const { Moengage } = window;

  isProduction && Moengage.track_event(event_name, obj);

  setTimeout(() => mixpanel.track(event_name, obj), 200);
};

const userProps = (obj) => {
  const { email, name, partner, id } = obj || {};
  const { phone } = partner || {};
  const [first_name, ...last_names] = name.split(" ");
  const last_name = last_names.join(" ");
  const { roleName: role } = getUserRoleBooleans(obj);

  return { email, name, id, phone, first_name, last_name, role };
};

const setMixpanelUser = (obj) => {
  const { id, email, ...props } = userProps(obj);

  let result = props;

  result["$email"] = email;

  mixpanel.identify(id);

  mixpanel.people.set(result);
};

const setMoengageUser = (obj) => {
  if (!isProduction) return;
  const { Moengage } = window;

  const props = userProps(obj);
  const { email, first_name, id, last_name, name, phone } = props || {};
  const { role, team } = obj || {};
  const { name: team_name } = team || {};

  const additionObj = pickBy({ role, team_name }, (val) => val);

  Moengage.add_unique_user_id(id);
  Moengage.add_first_name(first_name);
  Moengage.add_last_name(last_name);
  Moengage.add_email(email);
  Moengage.add_mobile(phone);
  Moengage.add_user_name(name);

  Object.keys(additionObj).forEach((key) => {
    const value = additionObj[key];
    Moengage.add_user_attribute(key, value);
  });
};

export const setUserEvents = (obj) => {
  const result = { ...obj, date: new Date() };

  setUserProperties(firebaseAnalytics(), result);

  setMoengageUser(result);

  setMixpanelUser(result);

  const { isAdminOrSuperAdmin, isEmployee, isBookKeeper } =
    getUserRoleBooleans(result);

  window.CommandBar?.addMetadata("userProperties", result);
  window.CommandBar?.addMetadata("isAdmin", isAdminOrSuperAdmin);
  window.CommandBar?.addMetadata("isBookkeeper", isBookKeeper);
  window.CommandBar?.addMetadata("isEmployee", isEmployee);
};

export const logoutEvents = (user) => {
  const { Moengage } = window;

  isProduction && Moengage.destroy_session();

  mixpanel.reset();
};
